import React from "react"
import { Card, CardBody, Spinner, Row, Col } from "reactstrap"
import { PaginationButton } from "components/Buttons"

const Pagination = ({ data, onPageChange }) => {
  const handleNextPage = () => {
    onPageChange(data.current_page + 1)
  }
  const handlePrevPage = () => {
    onPageChange(data.current_page - 1)
  }
  const handleLastPage = () => {
    onPageChange(data.last_page)
  }
  const handleFirstPage = () => {
    onPageChange(data.first_page)
  }
  return (
    <Row className="align-items-md-center mt-30 px-2">
      {data.current_page && <Col
        className="pagination pagination-rounded justify-content-end mb-2 align-items-md-center inner-custom-pagination">
        <div className={"px-2"}>
          {`${data.from} - ${data.to} of ${data.total_items}`}
        </div>
        <div className="btn-group" role="group">
          {data.first_page < data.current_page - 1 &&
          <PaginationButton
            icon={<i className={"bx bx-first-page bx-xs"}/>}
            onClick={handleFirstPage}
          />}

          {data.first_page < data.current_page &&
          <PaginationButton
            icon={<i className={"bx bx-chevron-left bx-xs"}/>}
            onClick={handlePrevPage}
          />}

          {data.last_page > data.current_page &&
          <PaginationButton
            icon={<i className={"bx bx-chevron-right bx-xs"}/>}
            onClick={handleNextPage}
          />}

          {data.last_page > data.current_page + 1 &&
          <PaginationButton
            icon={<i className={"bx bx-last-page bx-xs"}/>}
            onClick={handleLastPage}
          />}

        </div>
      </Col>
      }

    </Row>
  )
}

export default Pagination